export default __webpack_public_path__ + "images/index_block1_1.jpg";